import React, { useState } from 'react';
import { Col, Row } from 'antd';

import AddBuildingButton from '@totem/components/portfolio/buildings/list/buildingSummary/AddBuildingButton';
import BuildingsMapBoxMap from '@totem/components/portfolio/buildings/list/buildingSummary/BuildingsMapBoxMap';
import BuildingSummaryContainer from '@totem/components/portfolio/buildings/list/buildingSummary/BuildingSummaryContainer';
import BuildingSummaryTable from '@totem/components/portfolio/buildings/list/buildingSummary/BuildingSummaryTable';
import FilterChips from '@totem/components/portfolio/buildings/list/buildingSummary/FilterChips';
import NameSearch from '@totem/components/portfolio/buildings/list/buildingSummary/NameSearch';
import SquareFootageWrapper from '@totem/components/portfolio/buildings/list/squareFootage/SquareFootageWrapper';
import TreeMapChart from '@totem/components/portfolio/buildings/list/squareFootage/TreeMapChart';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

import './buildingSummary.css';
const BuildingSummaryPage = () => {
  const [totalRecords, setTotalRecords] = useState<number>(0);

  return (
    <ContentLayout>
      <BuildingSummaryContainer onRecordTotalChanged={setTotalRecords}>
        <IBCard
          isCovered
          title={'Building Management'}
          extra={<AddBuildingButton />}
        >
          <FilterChips />
          <Row>
            <Col span={12}>
              <BuildingsMapBoxMap />
            </Col>
            <Col span={12}>
              <SquareFootageWrapper>
                <TreeMapChart />
              </SquareFootageWrapper>
            </Col>
          </Row>
          <div styleName="search-container">
            <NameSearch />
            <div styleName="table-count">
              <RecordCountBadge count={totalRecords} />
            </div>
          </div>
          <div styleName="table-container">
            <BuildingSummaryTable />
          </div>
        </IBCard>
      </BuildingSummaryContainer>
    </ContentLayout>
  );
};

export default BuildingSummaryPage;
